import {z} from 'zod';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';
import {labourTypeSchema} from '@dms/shared-aftersales';

export const LabourMechanicSchema = z.object({
  id: z.string().nullish(),
  amount: z.number().nullish(),
  ratio: z.number().nullish(),
});

export const editItemFormSchema = z
  .object({
    sNo: z.string().nullish(),
    number: z.string().nullish(),
    name: z.string().nullish(),
    workType: z.string().nullish(),
    labourRateId: z.string().nullish(),
    workItemGroupId: z.string().nullish(),
    priceType: labourTypeSchema.nullish(),
    assignMechanics: z.array(LabourMechanicSchema).nullish(),
    quantity: z.number().positive(),
    purchasePricePerUnit: z.number().nullish(),
    sellingPricePerUnit: z.number(),
    sellingPrice: z.number().nullish(),
    vatType: z.string(),
    vatFreeCode: z.string().nullish(),
    isUnitPriceWithVat: z.boolean(),
    isCustomPrice: z.boolean(),
    customPriceType: z.enum(['perUnit', 'sellingPrice']),
    originalPurchasePricePerUnit: z.number().nullish(),
    originalSellingPricePerUnit: z.number().nullish(),
    isCustomDiscount: z.boolean(),
    isDoNotApplyDiscount: z.boolean(),
    discountRate: z.number().nullish(),
    discountType: z.string().nullish(),
    timeOutputPerUnit: z.number().nullish(),
  })
  .superRefine((data, ctx) => {
    if (
      data.isCustomDiscount &&
      data.discountType === 'manual-discount' &&
      isNil(data.discountRate)
    ) {
      ctx.addIssue({
        path: ['discountRate'],
        code: z.ZodIssueCode.custom,
        message: i18n.t('errors.field_is_required'),
      });
    }
  });

export type EditItemFormType = z.infer<typeof editItemFormSchema>;
